import {getCookie, setCookie} from '../../utils';

const reducer = (state = {current: getCookie("lan") ? getCookie("lan") : "en"}, action) => {
    switch (action.type) {
        case 'SET_CUR_LANG':
			setCookie("lan", action.current);
			return {...state, current: action.current}
			break;
		default: // need this for default case
      		return state ;
    }
}

export default reducer;